import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { http } from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const orderId = params.get("order_id");
  const [state, setState] = useState("checking"); // checking | paid | failed

  useEffect(() => {
    let attempts = 0;
    const check = async () => {
      attempts++;
      try {
        const { data } = await http.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
        } else if (attempts < 8) {
          setTimeout(check, 2000);
        } else {
          setState("failed");
        }
      } catch {
        if (attempts < 5) setTimeout(check, 2000);
        else setState("failed");
      }
    };
    if (sessionId) check();
  }, [sessionId]);

  return (
    <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="payment-success-page">
      {state === "checking" && (
        <>
          <Loader2 className="w-12 h-12 mx-auto animate-spin text-neutral-400" />
          <h1 className="font-display text-3xl mt-6 tracking-tighter">Confirmando pago...</h1>
          <p className="text-sm text-neutral-500 mt-2">Esto solo tomará unos segundos.</p>
        </>
      )}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-500" />
          <h1 className="font-display text-4xl mt-6 tracking-tighter">¡Pago confirmado!</h1>
          <p className="text-sm text-neutral-600 mt-3">Tu pedido está en producción. Te notificaremos cuando cambie de estatus.</p>
          <Button asChild className="brutal-btn bg-black hover:bg-[#FF3B30] text-white mt-6 h-12 px-6" data-testid="payment-view-order">
            <Link to={`/pedido/${orderId}`}>Ver mi pedido</Link>
          </Button>
        </>
      )}
      {state === "failed" && (
        <>
          <XCircle className="w-16 h-16 mx-auto text-neutral-400" />
          <h1 className="font-display text-3xl mt-6 tracking-tighter">No pudimos verificar el pago</h1>
          <p className="text-sm text-neutral-600 mt-3">Revisa tu pedido — si el cargo se realizó, se actualizará automáticamente.</p>
          <Button asChild className="brutal-btn bg-black text-white mt-6 h-12 px-6">
            <Link to={`/pedido/${orderId}`}>Ver mi pedido</Link>
          </Button>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  return (
    <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-16 h-16 mx-auto text-neutral-400" />
      <h1 className="font-display text-3xl mt-6 tracking-tighter">Pago cancelado</h1>
      <p className="text-sm text-neutral-600 mt-3">Tu pedido sigue creado. Puedes intentar el pago nuevamente cuando quieras.</p>
      <Button asChild className="brutal-btn bg-black text-white mt-6 h-12 px-6">
        <Link to={orderId ? `/pedido/${orderId}` : "/perfil"}>Volver al pedido</Link>
      </Button>
    </div>
  );
}
